import { PrimaryKey } from '../types/api/primaryKeys/PrimaryKey';
import { Nullable } from '../types/custom/Nullable';

/**
 * Parses the provided string as the type defined in the template.
 * IMPORTANT: Only call this in situations where strings must be dealt with.
 * This should be rare, except when processing route params, for example.
 * @param id 
 */
export function parseAsId<TPrimaryKey extends PrimaryKey>(id: string) {
    const result = Number.parseInt(id, 10) as TPrimaryKey;
    return result;
}

/**
 * Note: Prefer "parseAsId" in most cases.
 * This is most useful in situations where you really have an optional id, like perhaps mapping a select value to an integer.
 * Unlike "parseAsId", this will return NULL in the case the input cannot be parsed as a number.
 * @param id 
 */
export function tryParseAsId<TPrimaryKey extends PrimaryKey>(id: Nullable<string>) {
    if (id === null) { return null; }

    const numericResult = Number.parseInt(id, 10);

    return isNaN(numericResult) ? null : numericResult as TPrimaryKey;
}